import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { map } from 'rxjs/operators';

import { DeviceService } from '../../../../services/device.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-guard',
  templateUrl: './main-nav-guard.component.html',
  styleUrl: './main-nav-guard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MainNavService],
  standalone: false
})
export class MainNavGuardComponent {
  @Input()
  hideHeader = false; // hide header

  @Input()
  hideSearch = false; // hide only search (tablet version), if 'hideHeader' is set to FALSE - this is ignored

  @Input()
  isScrolled = false; // make smaller for business - TODO clarify with designer and probably remove

  hasUser$ = this.mainNavService.loggedUser$.pipe(map(user => !!user));
  device$ = this.deviceService.type$;
  isPlatform$ = this.mainNavService.isPlatform$;

  constructor(
    private mainNavService: MainNavService,
    private deviceService: DeviceService
  ) {}
}
